import { commitmentDocument } from './commitmentDocument';
import { contact } from './contact';
import { member as base } from './member';

export const member = {
  ...base,
  ...contact,
  ...commitmentDocument,
};
